import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import ReactTable from 'react-table';

import { BigBreadcrumbs, JarvisWidget, WidgetGrid } from '../../../components';
import Pagination from '../../../components/common/Pagination';
import {
  getClientFile
} from '../../../store/client-manager/ClientManagerActions';
import { isExternalStakeholder, isOrganizationalClient } from '../../../store/current-user/CurrentUserSelectors';
import { requestFiles } from '../../../store/files/FilesActions';

class Files extends Component {
  constructor(props) {
    super(props);
    this.state = { pageSize: 25, page: 0, pages: -1, search: '', sorted: [] };
  }

  componentWillMount() {
    const { tenantId, getFiles } = this.props;
    getFiles({ tenantId });
  }

  downloadFile(client, fileName) {
    const { tenantId } = this.props;
    this.props
      .getClientFile(
        client,
        {
          tenantId: tenantId,
        },
        fileName,
      )
      .then((response) => {
        const blob = response.payload;
        const a = document.createElement('a');
        const url = window.URL.createObjectURL(blob);
        a.href = url;
        a.download = fileName;
        a.click();
        window.URL.revokeObjectURL(url);
      });
  }

  render() {
    return (
      <div id="content">
        <Helmet title="Files – Telemetry" />
        <div className="table-layout content-ribbon">
          <div className="table-cell">
            <BigBreadcrumbs
              items={['Reports & Analytics', 'Files']}
              icon="fa fa-fw fa-bar-chart-o"
              className=""
            />
          </div>
          <div className="table-cell">
          </div>
        </div>
        <WidgetGrid>
          <div className="row">
            <article className="col-sm-12">
              <JarvisWidget
                color="white"
                fullscreenbutton={true}
                colorbutton={false}
                editbutton={false}
                togglebutton={false}
                deletebutton={false}
              >
                <header>
                  <span className="widget-icon">
                    {' '}
                    <i className="fa fa-table" />{' '}
                  </span>{' '}
                  <h2>Files</h2>
                </header>
                <div>
                  <div className="widget-body no-padding">
                    <ReactTable
                      ref={(instance) => {
                        this.table = instance;
                      }}
                      page={this.state.page}
                      manual
                      pages={this.state.pages}
                      loading={this.props.isLoading}
                      data={this.props.data ? this.props.data : []}
                      onFetchData={this.fetchData}
                      columns={[
                        {
                          Header: 'File Name',
                          id: 'fileName',
                          accessor: 'fileName',
                        },
                        {
                          Header: 'Client',
                          id: 'client',
                          accessor: 'client',
                        },
                        {
                          Header: 'Actions',
                          Cell: (row) => (
                            <div>
                              <button
                                className="btn btn-xs btn-default"
                                onClick={() =>
                                  this.downloadFile(row.original.client, row.original.fileName)
                                }
                              >
                                <i className="fa fa-download" />
                              </button>
                            </div>
                          ),
                        }
                      ]}
                      defaultPageSize={this.state.pageSize}
                      onPageSizeChange={(pageSize) =>
                        this.setState({ pageSize })
                      }
                      onPageChange={(page) => this.setState({ page })}
                      filterable
                      className="-striped -highlight"
                      showPaginationTop={true}
                      PaginationComponent={Pagination}
                      onSearchChange={this.handleSearch}
                    />
                  </div>
                </div>
              </JarvisWidget>
            </article>
          </div>
        </WidgetGrid>
      </div>
    );
  }
}
const flattenFileList = (data) => {
  const flatten = [];
  if (data) {
    for (const [client, files] of Object.entries(data)) {
      if (Array.isArray(files)) {
        files.forEach(file => {
          flatten.push({
            fileName: file,
            client: client
          })
        });
      }
    }
  }
  return flatten;
}

export default connect(
  state => ({
    data: flattenFileList(state.files.list),
    tenantId: state.currentUser.queryParams.tenantId,
    isOrganizationalClient: isOrganizationalClient(state) || isExternalStakeholder(state),
  }),
  dispatch => ({
    getClientFile: (employerCodeNumber, params, file) =>
      dispatch(getClientFile(employerCodeNumber, params, file)),
    getFiles: (params) => dispatch(requestFiles(params)),
  }),
)(Files);



// WEBPACK FOOTER //
// ./src/routes/reports-analytics/containers/Files.js